import { find, some } from "lodash-es";
import { MultiselectHitType } from "src/types/Algolia";

export const getSelectedNodes = (
  items: MultiselectHitType[],
  slug: string
): MultiselectHitType[] | undefined => {
  const item = find(items, (hit) => {
    return some(hit.items, (e) => e.label?.split("||")[2] === slug);
  });
  if (item) {
    return item.items;
  } else if (items) {
    let i = 0;
    while (i < items.length) {
      const hit = items[i++];
      const itemsWithSelectedChild = getSelectedNodes(hit.items, slug);
      if (itemsWithSelectedChild) {
        return itemsWithSelectedChild;
      }
    }
  }
  return undefined;
};
